import { LicenseTypeEnum } from '../enums/license-type.enum';

export class SubscriptionUtils {
  static isUpgradableTo(from: LicenseTypeEnum, to: LicenseTypeEnum) {
    const licensesInOrder: LicenseTypeEnum[] = [
      LicenseTypeEnum.Student,
      LicenseTypeEnum.Questionnaire,
      LicenseTypeEnum.Individual,
      LicenseTypeEnum.Team,
      LicenseTypeEnum.Enterprise,
    ];

    return licensesInOrder.indexOf(to) > licensesInOrder.indexOf(from);
  }

  static isTheSameOrUpgradable(from: LicenseTypeEnum, to: LicenseTypeEnum) {
    const licensesInOrder: LicenseTypeEnum[] = [
      LicenseTypeEnum.Student,
      LicenseTypeEnum.Questionnaire,
      LicenseTypeEnum.Individual,
      LicenseTypeEnum.Team,
      LicenseTypeEnum.Enterprise,
    ];

    return licensesInOrder.indexOf(to) >= licensesInOrder.indexOf(from);
  }

  static isADowngradeFrom(from: LicenseTypeEnum, to: LicenseTypeEnum) {
    const licensesInOrder: LicenseTypeEnum[] = [
      LicenseTypeEnum.Student,
      LicenseTypeEnum.Questionnaire,
      LicenseTypeEnum.Individual,
      LicenseTypeEnum.Team,
      LicenseTypeEnum.Enterprise,
    ];

    return licensesInOrder.indexOf(to) < licensesInOrder.indexOf(from);
  }

  static isTheSameOrADowngradeFrom(from: LicenseTypeEnum, to: LicenseTypeEnum) {
    const licensesInOrder: LicenseTypeEnum[] = [
      LicenseTypeEnum.Student,
      LicenseTypeEnum.Questionnaire,
      LicenseTypeEnum.Individual,
      LicenseTypeEnum.Team,
      LicenseTypeEnum.Enterprise,
    ];

    return licensesInOrder.indexOf(to) <= licensesInOrder.indexOf(from);
  }
}